import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GGFirmwareWSDTO } from '../components/gg-firmware-verification/gg-firmware-verification.component';
import { GgFirmwareVerificationConnector } from '../data-bindings/firmware-verification/gg-firmware-verification-connector.service';

@Injectable({
  providedIn: 'root',
})
export class GgFirmwareVerificationService {
  constructor(protected firmwareVerificationConnector: GgFirmwareVerificationConnector) {}

  checkFirmware(extraId: string): Observable<GGFirmwareWSDTO[]> {
    return this.firmwareVerificationConnector.checkFirmware(extraId);
  }
}
